<template>
  <div class="admin-disabled-companies">
    <v-card class="mt-4">
      <v-card-title class="d-flex align-center mb-7">
        <h3>لیست شرکت های غیرفعال</h3>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="جستجو بر اساس نام شرکت، مدیر و دسته بندی"
          class="flex-fill mx-7 mt-0 pt-0"
          single-line
          hide-details
        ></v-text-field>
        <v-btn
          depressed
          small
          outlined
          color="accent"
          router
          :to="{ name: 'AdminCompanies' }"
        >
          بازگشت
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="companies"
        :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
        :search="search"
        :loading="loading"
        :expanded="companies"
        show-expand
        single-expand
        disable-sort
        fixed-header
        item-key="_id"
      >
        <template v-slot:[`item.name`]="{ item }">
          <div class="d-flex align-center">
            <div v-if="item.promoted">
              <v-avatar color="yellow accent-4 ml-2" size="25">
                <v-icon small class="white--text">mdi-star</v-icon>
              </v-avatar>
            </div>
            <v-avatar size="35" class="ml-5">
              <v-img
                v-if="item.logo"
                :src="`http://localhost:3000/company/${item._id}/image`"
              />
              <v-img v-else src="~@/assets/images/logo-placeholder.jpg" />
            </v-avatar>
            <div class="text-no-wrap">{{ item.name }}</div>
          </div>
        </template>

        <template v-slot:[`item.moderator`]="{ item }">
          <div class="text-no-wrap">{{ item.moderator }}</div>
        </template>

        <template v-slot:[`item.type`]="{ item }">
          <div v-if="item.type == 'plastic'" class="text-no-wrap">
            پلاستیک، لاستیک و کامپوزیت
          </div>
          <div v-if="item.type == 'glue'" class="text-no-wrap">
            پوشرنگ، رزین و چسب
          </div>
          <div v-if="item.type == 'packing'" class="text-no-wrap">
            بسته‌بندی
          </div>
        </template>

        <template v-slot:[`item._id`]="{ item }">
          <div class="d-flex align-center justify-center">
            <v-btn
              depressed
              small
              outlined
              color="accent"
              class="mx-2"
              router
              :to="{ name: 'Edit', params: { id: item._id } }"
            >
              <v-icon class="text-body-2 ml-1">mdi-pen</v-icon>
              ویرایش
            </v-btn>
            <v-btn
              depressed
              small
              outlined
              color="success"
              class="mx-2"
              @click="handleEnableCompamies(item._id)"
            >
              <v-icon class="text-body-2 ml-1">mdi-check</v-icon>
              فعال
            </v-btn>
            <v-btn
              depressed
              small
              outlined
              color="error"
              class="mx-2"
              @click="handleDeleteCompamies(item._id)"
            >
              <v-icon class="text-body-2 ml-1">mdi-close</v-icon>
              حذف
            </v-btn>
          </div>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div class="d-flex align-center py-3">
              <div class="text-caption flex-fill">
                <strong>آدرس: </strong>
                <span v-if="item.address">{{ item.address }}</span>
                <span v-else>-</span>
                <v-chip
                  v-if="item.postalcode"
                  small
                  label
                  color="grey lighten-4"
                  class="mr-2"
                >
                  <div class="text-catption">
                    کد پستی: {{ item.postalcode }}
                  </div>
                </v-chip>
              </div>

              <v-btn
                class="mx-1"
                outlined
                rounded
                color="grey darken-3"
                style="height: 32px"
                :href="`tel:${item.tel}`"
                v-if="item.tel"
              >
                <v-icon left>mdi-phone</v-icon>
                <small>{{ item.tel }}</small>
              </v-btn>

              <v-btn
                class="mx-1"
                outlined
                rounded
                color="grey darken-3"
                style="height: 32px"
                v-if="item.fax"
              >
                <v-icon left>mdi-fax</v-icon>
                <small>{{ item.fax }}</small>
              </v-btn>

              <v-btn
                class="mx-1"
                outlined
                fab
                x-small
                color="grey darken-3"
                :href="`http://${item.website}`"
                target="_blank"
                v-if="item.website"
              >
                <v-icon>mdi-web</v-icon>
              </v-btn>

              <v-btn
                class="mx-1"
                outlined
                fab
                x-small
                color="grey darken-3"
                :href="`mailto:${item.email}`"
                target="_blank"
                v-if="item.email"
              >
                <v-icon>mdi-email</v-icon>
              </v-btn>
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AdminDisabledCompanies",
  data() {
    return {
      loading: true,
      search: "",
      categories: [],
      headers: [
        {
          text: "نام شرکت",
          value: "name",
          align: "center",
          width: 200
        },
        {
          text: "مدیر",
          value: "moderator",
          align: "center",
          width: 200
        },
        {
          text: "دسته‌بندی",
          value: "type",
          align: "center",
          width: 200
        },
        {
          text: "اقدامات",
          value: "_id",
          align: "center",
          width: 400
        }
      ],
      companies: []
    };
  },
  created() {
    this.handleGetCompanies();
  },
  methods: {
    handleGetCompanies() {
      this.loading = true;
      this.companies = [];
      this.$api
        .get(`unaproved-companies?timestamp=${new Date().getTime()}`)
        .then((res) => {
          this.companies = res.data.companies;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    handleEnableCompamies(id) {
      this.loading = true;
      this.companies = [];
      this.$api
        .post("company/enable", {
          company: id
        })
        .then(() => {
          this.handleGetCompanies();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleDeleteCompamies(id) {
      this.loading = true;
      this.companies = [];
      this.$api
        .delete("company/" + id)
        .then(() => {
          this.handleGetCompanies();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>
